import { yupResolver } from '@hookform/resolvers/yup'
import React, { Fragment, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import tw from 'twin.macro'

import { Button } from '../components/UI/button/button'
import { MaskedInput } from '../components/UI/input/masked-input'
import SubBody from '../components/UI/sub-body/sub-body'
import { useCreateActivationMutation } from '../redux/api/mega-card-activation.api'
import { createPhoneSchema } from '../share/schemas/phone.schema'

function PhoneEnterActivationPage() {
  const { t, i18n } = useTranslation(['auth'])
  const phoneSchema = useMemo(() => createPhoneSchema(t), [t])
  const [createActivation, { isLoading }] = useCreateActivationMutation()
  const navigate = useNavigate()

  const {
    control,
    formState: { errors, isValid },
    getValues,
    setError
  } = useForm({
    defaultValues: { mobile_phone: '' },
    resolver: yupResolver(phoneSchema),
    mode: 'onChange'
  })

  const handleSendOtp = async () => {
    try {
      const mobilePhone = getValues().mobile_phone.replace(/[()\s]/g, '')
      await createActivation({ mobile_phone: mobilePhone }).unwrap()
      navigate('/verify')
    } catch (error) {
      const typedError = error as {
        data: {
          error: { description: string; code: string }
        }
      }
      setError('mobile_phone', { type: 'limit', message: typedError.data.error.description })
    }
  }

  return (
    <div key={i18n.language} tw='flex items-center justify-center mt-5 sm:mt-0'>
      <div tw='w-[500px] p-10 bg-secondary rounded-s20 flex flex-col gap-6'>
        <Fragment>
          <div>
            <MaskedInput
              control={control}
              name='mobile_phone'
              label={t('mobile_phone')}
              mask='+7(999)999 99 99'
              placeholder='+7 ( _ _ _ ) _ _ _  _ _  _ _'
              error={errors.mobile_phone?.message}
            />
          </div>
          <Button variant='gradient' loading={isLoading} disabled={!isValid} onClick={() => handleSendOtp()}>
            {t('receive_sms')}
          </Button>
          <div>
            <SubBody twStyle={tw`text-secondary`}>
              <Trans
                i18nKey='agreement'
                ns='auth'
                components={{
                  link1: (
                    <a
                      href='https://bankffin.kz/storage/docs/DW6oJlZFR8SQOYyRgJuIdKMYLXAj4M7qbhtMzdma.pdf'
                      target='_blank'
                      rel='noreferrer'
                      tw='underline font-bold'
                    />
                  )
                }}
              />
            </SubBody>
          </div>
        </Fragment>
      </div>
    </div>
  )
}

export default PhoneEnterActivationPage
